module.exports = __webpack_public_path__ + "img/planet.33ff32a2.png";